export default __webpack_public_path__ + "i18n/translations/translation-pl.25d89540.json";